module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_3016.de74caa1.png";